import { render, staticRenderFns } from "./IndexAndGenusManagePage.vue?vue&type=template&id=40f9e033&scoped=true&"
import script from "./IndexAndGenusManagePage.vue?vue&type=script&lang=js&"
export * from "./IndexAndGenusManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9e033",
  null
  
)

export default component.exports